import { useEffect } from "react";
import { io } from "socket.io-client";
import { PaymentMethod } from "../constants/payment";

/**
 * Custom hook for Socket.IO connection to listen for payment success
 */
export function usePaymentSocket(
  method,
  merchantOrderId,
  socketUrl,
  returnUrl
) {
  useEffect(() => {
    if (method !== PaymentMethod.QR_CODE || !merchantOrderId || !socketUrl) {
      return;
    }

    const socket = io(socketUrl, { transports: ["websocket"] });
    const eventName = "success-order" + merchantOrderId;

    const handler = (msg) => {
      try {
        // Attempt to parse JSON, but ignore errors
        JSON.parse(msg);
      } catch {}

      if (returnUrl) {
        window.location.replace(returnUrl);
      }
    };

    socket.on(eventName, handler);

    return () => {
      socket.off(eventName, handler);
      socket.disconnect();
    };
  }, [method, merchantOrderId, socketUrl, returnUrl]);
}